import React, { useState } from 'react';
import { auth } from './firebase'; // Adjust the path as needed
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const Register = () => {
  const [name, setName] = useState(''); // State for name
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState(''); // State for confirm password
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(''); // State for success message
  const [loading, setLoading] = useState(false); // State for loading status
  const navigate = useNavigate(); // Initialize useNavigate

  const handleRegister = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords don't match"); // Check for password match
      return;
    }

    setLoading(true); // Set loading to true
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await sendEmailVerification(user); // Send verification email
      setSuccess('Registration successful! Please check your email for verification link.'); // Set success message
      setError(''); // Clear any previous error
      // Redirect to login after a delay
      setTimeout(() => {
        navigate('/login'); // Redirect to the login page
      }, 2000); // Delay for 2 seconds
    } catch (err) {
      setError(err.message);
      setSuccess(''); // Clear success message on error
    } finally {
      setLoading(false); // Set loading to false
    }
  };

  const handleNavigateToLogin = () => {
    navigate('/login'); // Navigate to the login page
  };

  return (
    <div style={styles.container}>
      <img src={require('./register.webp')} alt="Registration Animation" style={styles.gif} /> {/* Add GIF here */}
      <h2 style={styles.title}>Register</h2>
      {error && <p style={styles.error}>{error}</p>}
      {success && <p style={styles.success}>{success}</p>} {/* Display success message */}
      <form onSubmit={handleRegister} style={styles.form}>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={styles.input}
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          required
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? 'Registering...' : 'Register'}
        </button>
      </form>
      <label onClick={handleNavigateToLogin}>
        <h5>Already have an account? Sign In</h5>
      </label>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: 'black',
    color: '#00FFFF',
  },
  gif: {
    width: '300px', // Adjust size as needed
    height: 'auto',
    marginBottom: '20px',
  },
  title: {
    marginBottom: '20px',
    fontSize: '2rem',
  },
  error: {
    color: 'red',
  },
  success: {
    color: 'green', // Style for success message
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  input: {
    padding: '10px',
    margin: '5px',
    borderRadius: '5px',
    border: '1px solid #00FFFF',
    width: '300px',
    backgroundColor: 'white',
    color: 'black',
  },
  button: {
    backgroundColor: '#00FFFF',
    color: 'black',
    border: 'none',
    padding: '10px 20px',
    margin: '10px 0',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },
};

export default Register;
